
export default function Footer() {
  return (
    <footer>
      <p>{`JAMix By Design © ${new Date().getFullYear()}`}</p>
    </footer>
  )
}
